import Link from 'next/dist/client/link';
import { useMemo } from 'react';

import type { ImageInfo } from './lib';

import css from './card.css';

export const BlogCard: VFC<{
    href: string;
    title: string;
    description: string;
    teaserImg: ImageInfo;
}> = ({ description, href, teaserImg, title }) => {
    const imgStyle: CSSProperties = useMemo(
        () =>
            teaserImg
                ? {
                      aspectRatio: `${teaserImg.width / teaserImg.height}`
                  }
                : undefined,
        [teaserImg]
    );

    return (
        <Link href={href}>
            <a className={css.card}>
                <h3 className={css.title}>{title}</h3>
                <div className={css.body}>
                    {teaserImg && (
                        <img
                            alt={title}
                            className={css.img}
                            height={teaserImg.height}
                            src={teaserImg.url}
                            style={imgStyle}
                            width={teaserImg.width}
                        />
                    )}
                    <p className={css.description}>{description}</p>
                </div>
            </a>
        </Link>
    );
};
